import { flattenValues } from "../../../../../../../../utils/flattenValues"
import { formatDateSaveDB } from "../../../../../../../../utils/getDate"
import { SchedulesExportFRM103PostType } from "../../../../../models/list/export"
import { SchedulesSearchFormDataType } from "../../../../../models/list/search"

export const convertDataSearch = ({
  arrivalDateTimeDate,
  countryToTravel,
  departureDateTimeDate,
  dispatchTypeDetail,
  transitSearchType,
  ...values
}: SchedulesSearchFormDataType): SchedulesExportFRM103PostType => ({
  ...values,
  arrivalDateTime: arrivalDateTimeDate
    ? formatDateSaveDB(arrivalDateTimeDate.toString(), true)
    : "",
  countryToTravel: flattenValues(countryToTravel),
  departureDateTime: departureDateTimeDate
    ? formatDateSaveDB(departureDateTimeDate.toString())
    : "",
  dispatchTypeDetail: flattenValues(dispatchTypeDetail as string[][]),
  transitSearchType,
})
